export default __webpack_public_path__ + "static/Century_Gothic_ItBd-bd279bffcd4941ede2f75f32f8cf8d62.woff2";